<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <b class="red">*</b>
          <span class="line-text">账户名称：</span>
        </div>
        <el-input type="text" v-model="formData.aliAccountName" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">支付宝账号：</span>
        </div>
        <el-input type="text" v-model="formData.aliAccount" size="small" style="width: 280px" />
      </div>
<!--      <div class="form-line">-->
<!--        <div class="textBox">-->
<!--          <b class="red">*</b>-->
<!--          <span class="line-text">支付宝APPID：</span>-->
<!--        </div>-->
<!--        <el-input type="text" v-model="formData.aliAccountAppid" size="small" style="width: 280px" />-->
<!--      </div>-->
<!--      <div class="form-line">-->
<!--        <div class="textBox">-->
<!--          <b class="red">*</b>-->
<!--          <span class="line-text">支付宝PID：</span>-->
<!--        </div>-->
<!--        <el-input type="text" v-model="formData.aliAccountPid" size="small" style="width: 280px" />-->
<!--      </div>-->
<!--      <div class="form-line">-->
<!--        <div class="textBox">-->
<!--          <b class="red">*</b>-->
<!--          <span class="line-text">授权有效期起始：</span>-->
<!--        </div>-->
<!--        <el-date-picker v-model="formData.authorizationStartTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择出生年月" size="small" style="width: 280px"></el-date-picker>-->
<!--      </div>-->
<!--      <div class="form-line">-->
<!--        <div class="textBox">-->
<!--          <b class="red">*</b>-->
<!--          <span class="line-text">授权有效期结束：</span>-->
<!--        </div>-->
<!--        <el-date-picker v-model="formData.authorizationEndTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择出生年月" size="small" style="width: 280px"></el-date-picker>-->
<!--      </div>-->

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../../utils/toBase64'
  import {bus} from '../../../../utils/bus'
  import {api} from '../../../api/ParkingService'
  import {nError, nSuccess} from '../../../../utils/notice'
  import {errorHandler} from '../../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'ali-account-add',
    data () {
      return {
        breadcrumb: [{
          value: "智慧停车",
          name: "parking-device-management"
        }, {
          value: '支付宝账户配置'
        }],
        mainTitle: '添加支付宝账户',
        subheading: '',

        formData: {
          aliAccountName: '',
          aliAccount: '',
          aliAccountAppid: '',
          aliAccountPid: '',
          authorizationStartTime: '',
          authorizationEndTime: '',
        },

        deviceList: []
      }
    },
    created () {

    },
    methods: {
      toManagementPage () {
        this.$router.push({
          name: 'parking-ali-account-manage'
        })
      },

      // 添加
      confirm () {
        if (!this.formData.aliAccountName) {
          nError('请输入账户名称')
          return false
        }
        if (!this.formData.aliAccount) {
          nError('请输入支付宝账号')
          return false
        }
        // if (!this.formData.aliAccountAppid) {
        //   nError('请输入支付宝APPID')
        //   return false
        // }
        // if (!this.formData.aliAccountPid) {
        //   nError('请输入支付宝PID')
        //   return false
        // }
        // if (!this.formData.authorizationStartTime) {
        //   nError('请输入授权有效期起始')
        //   return false
        // }
        // if (!this.formData.authorizationEndTime) {
        //   nError('请输入授权有效期结束')
        //   return false
        // }
        this.$axios.post(api.addAliMoneyAccount, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.toManagementPage()
            }
          })
          .catch(errorHandler('添加失败'))
      },

      cancel () {
        this.toManagementPage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 140px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/ParkingService/CollectionAccount/aliAccountConfig/aliAccountAdd.vue